import { isly } from "isly";
import { Precision } from "./Precision";
export var Numeric;
(function (Numeric) {
    var _a;
    _a = isly
        .object({
        hours: isly.number().optional(),
        minutes: isly.number().optional(),
        seconds: isly.number().optional(),
        milliseconds: isly.number().optional(),
    }, "isoly.Time.Numeric")
        .bind(), Numeric.type = _a.type, Numeric.is = _a.is, Numeric.flawed = _a.flawed;
    function create(epoch, precision = "seconds") {
        const integerDivision = (dividend, divisor) => [Math.trunc(dividend / divisor), dividend % divisor];
        const [s, milliseconds] = integerDivision(epoch * Precision.factor[precision], 1000);
        const [m, seconds] = integerDivision(s, 60);
        const [hours, minutes] = integerDivision(m, 60);
        return {
            hours,
            minutes,
            seconds,
            milliseconds,
        };
    }
    Numeric.create = create;
    function parse(time) {
        const [hours, minutes, secondsMilliseconds] = time?.split(":", 3) ?? [];
        const [seconds, milliseconds] = secondsMilliseconds?.split(".", 2) ?? [];
        return {
            hours: hours != undefined ? Number.parseInt(hours) : undefined,
            minutes: minutes != undefined ? Number.parseInt(minutes) : undefined,
            seconds: seconds != undefined ? Number.parseInt(seconds) : undefined,
            milliseconds: milliseconds != undefined ? Number.parseInt(milliseconds.slice(0, 3).padEnd(3, "0")) : undefined,
        };
    }
    Numeric.parse = parse;
    function epoch(time, precision = "seconds") {
        const result = (((time.hours ?? 0) * 60 + (time.minutes ?? 0)) * 60 + (time.seconds ?? 0)) * 1000 + (time.milliseconds ?? 0);
        return Math.trunc(result / Precision.factor[precision]);
    }
    Numeric.epoch = epoch;
    function truncate(time, precision) {
        const result = { ...time };
        switch (precision) {
            case "hours":
                delete result.minutes;
            case "minutes":
                delete result.seconds;
            case "seconds":
                delete result.milliseconds;
        }
        return result;
    }
    Numeric.truncate = truncate;
    function normalize(time, precision) {
        return truncate(create(epoch(time, "milliseconds"), "milliseconds"), precision ?? Numeric.precision(time));
    }
    Numeric.normalize = normalize;
    function format(time, precision) {
        if (!precision)
            precision = Numeric.precision(time);
        const normalized = normalize(time, precision);
        let result = "";
        switch (precision) {
            case "milliseconds":
                result = `.${(normalized.milliseconds ?? 0).toString().padStart(3, "0")}`;
            case "seconds":
                result = `:${(normalized.seconds ?? 0).toString().padStart(2, "0") + result}`;
            case "minutes":
                result = `:${(normalized.minutes ?? 0).toString().padStart(2, "0") + result}`;
            case "hours":
                result = `${(normalized.hours ?? 0).toString().padStart(2, "0") + result}`;
        }
        return result;
    }
    Numeric.format = format;
    function precision(time) {
        return time.milliseconds != undefined
            ? "milliseconds"
            : time.seconds != undefined
                ? "seconds"
                : time.minutes != undefined
                    ? "minutes"
                    : "hours";
    }
    Numeric.precision = precision;
})(Numeric || (Numeric = {}));
//# sourceMappingURL=Numeric.js.map